import * as React from 'react';

import * as styles from './LinkArea.css';
import { clsx } from 'clsx';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  preventDefault?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
  dataName?: string;
}

export function LinkArea({ href, children, target, dataName, ...divProps }: ILinkAreaProps) {
  return (
    <div {...divProps} className={clsx(styles['container'], divProps.className)} data-name={dataName}>
      <a href={href} className={styles['link']} target={target}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
